"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceFeatures = exports.EntitlementStatus = exports.EntitlementType = void 0;
var EntitlementType;
(function (EntitlementType) {
    EntitlementType["PRODUCT"] = "PRODUCT";
    EntitlementType["GEOGRAPHY"] = "GEOGRAPHY";
    EntitlementType["REPORT"] = "REPORT";
    EntitlementType["ALL_GEOGRAPHY"] = "ALL_GEOGRAPHY";
    EntitlementType["TAG"] = "TAG";
    EntitlementType["PATH"] = "PATH";
    EntitlementType["ELASTIC_DSL"] = "ELASTIC_DSL";
    EntitlementType["MARKETPLACE_FEATURES"] = "MARKETPLACE_FEATURES";
    EntitlementType["RELEVANCE_TAG"] = "RELEVANCE_TAG";
})(EntitlementType = exports.EntitlementType || (exports.EntitlementType = {}));
var EntitlementStatus;
(function (EntitlementStatus) {
    EntitlementStatus["ACTIVE"] = "ACTIVE";
    EntitlementStatus["INACTIVE"] = "INACTIVE";
})(EntitlementStatus = exports.EntitlementStatus || (exports.EntitlementStatus = {}));
var MarketplaceFeatures;
(function (MarketplaceFeatures) {
    MarketplaceFeatures["PROJECT_MODULE"] = "PROJECT_MODULE";
    MarketplaceFeatures["LITE_UI"] = "LITE_UI";
})(MarketplaceFeatures = exports.MarketplaceFeatures || (exports.MarketplaceFeatures = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW50aXRsZW1lbnQuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnRpdGxlbWVudC10ZW1wbGF0ZS90eXBlcy9lbnRpdGxlbWVudC5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksZUFVWDtBQVZELFdBQVksZUFBZTtJQUN6QixzQ0FBbUIsQ0FBQTtJQUNuQiwwQ0FBdUIsQ0FBQTtJQUN2QixvQ0FBaUIsQ0FBQTtJQUNqQixrREFBK0IsQ0FBQTtJQUMvQiw4QkFBVyxDQUFBO0lBQ1gsZ0NBQWEsQ0FBQTtJQUNiLDhDQUEyQixDQUFBO0lBQzNCLGdFQUE2QyxDQUFBO0lBQzdDLGtEQUErQixDQUFBO0FBQ2pDLENBQUMsRUFWVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQVUxQjtBQUVELElBQVksaUJBR1g7QUFIRCxXQUFZLGlCQUFpQjtJQUMzQixzQ0FBaUIsQ0FBQTtJQUNqQiwwQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsaUJBQWlCLEdBQWpCLHlCQUFpQixLQUFqQix5QkFBaUIsUUFHNUI7QUFFRCxJQUFZLG1CQUdYO0FBSEQsV0FBWSxtQkFBbUI7SUFDN0Isd0RBQWlDLENBQUE7SUFDakMsMENBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUhXLG1CQUFtQixHQUFuQiwyQkFBbUIsS0FBbkIsMkJBQW1CLFFBRzlCIn0=